import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import format from '../../helpers/format'
import {
  LinkIcon
} from '../../components'

const Styles = require('./TargetDateSeriesFundDetails.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesFundDetails extends Component {
  static propTypes = {
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
    this.state = {
      targetDateSeries: props.targetDateSeries,
      showFundDetails: false
    }
  }

  render() {
    const { showFundDetails, targetDateSeries } = this.state

    return (
      <div styleName='fund-details-wrap'>
        <button
          styleName='fund-details-button'
          onClick={
            () => {
              this.setState(
                {
                  showFundDetails: !showFundDetails
                }
              )
            }
          }
        >
          Fund details<LinkIcon
            faclass={
              showFundDetails ?
                'fa-chevron-up' :
                'fa-chevron-down'
            }
          />
        </button>
        <SlideDown>
          {
            showFundDetails ?
              (
                <div>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Target date fund series name
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{targetDateSeries.strategy_name}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund name
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{targetDateSeries.fund_legal_name}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund tickers
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{targetDateSeries.tickers}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund manager
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{targetDateSeries.fund_family_name || targetDateSeries.fund_family_label }</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund group
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{targetDateSeries.category_group}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Percent rated
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{format.perc(targetDateSeries.percent_rated)}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Percent rated, long assets
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{format.perc(targetDateSeries.percent_rated_long )}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund net assets
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{format.money(targetDateSeries.net_assets,true,'US Dollar')}</b>
                    </Col>
                  </Row>
                </div>
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }
}